import { InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";

import Colors from "../../../../../../../global/Colors";
import Title from "../../components/Title";
import { useProCliStore } from "../hooks/useProCliStore";

import { TEXTFIELD_TYPES } from "./CustomTextFieldTypes";

export default function CustomTextField({
  index,
  title,
  subTitle,
  defaultValue,
  placeholder,
  width = "w-full",
  disabled = false,
  updateProviderInfo,
  fieldName,
  activateButtons,
  deactivateButtons,
  validatorFunction = null,
  type = "",
}) {
  const { providersData } = useProCliStore();
  const [initialValue, setInitialValue] = useState(defaultValue);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setInitialValue(defaultValue);
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (validatorFunction !== null) {
      if (!validatorFunction(value, setValue, setError, setHelperText)) {
        deactivateButtons(true, false);
        return;
      }
    } else {
      setValue(event.target.value);
    }
    const existingFields = providersData.get(index).editableFields;
    let editableData = null;
    if (value === initialValue) {
      if (existingFields && Object.keys(existingFields).length > 1) {
        editableData = {
          ...existingFields,
        };
        delete editableData[fieldName];
      }
      const updatedData = new Map(providersData);
      updatedData.set(index, {
        ...updatedData.get(index),
        editableFields: editableData,
      });
      updateProviderInfo(updatedData);
      return;
    }
    activateButtons();
    if (
      (value && value.trim()) ||
      (existingFields &&
        (Object.keys(existingFields).length !== 0 || value !== existingFields[fieldName]))
    ) {
      editableData = {
        ...existingFields,
        [fieldName]: value,
      };
    }
    const updatedData = new Map(providersData);
    updatedData.set(index, {
      ...updatedData.get(index),
      editableFields: editableData,
    });

    updateProviderInfo(updatedData);
  };

  return (
    <div className="flex w-full flex-col items-start justify-start pr-2">
      <div>
        <Title text={title} size={"text-xs"} horizontalPadding="pl-2" className="block w-full" />
        {subTitle && (
          <Title
            text={"(" + subTitle + ")"}
            size={"text-[0.65rem]"}
            color="text-gray-400"
            fontStyle="normal-case"
            horizontalPadding="pl-2"
          />
        )}
      </div>

      <TextField
        error={error}
        disabled={disabled}
        defaultValue={defaultValue !== null ? defaultValue : ""}
        placeholder={defaultValue === "" ? placeholder : ""}
        size="small"
        className={`text-sm ${width} px-0 pt-1`}
        InputProps={{
          startAdornment: type === TEXTFIELD_TYPES.CURRENCY && (
            <InputAdornment position="start">$</InputAdornment>
          ),
          sx: {
            lineHeight: "1rem",
            borderRadius: "50px",
            backgroundColor: disabled ? Colors.gray[200] : Colors.white,
          },
        }}
        helperText={helperText}
        onChange={handleChange}
        value={value}
        type={type === TEXTFIELD_TYPES.CURRENCY && "number"}
      />
    </div>
  );
}
